import { render, staticRenderFns } from "./ExercisePresetEdit.vue?vue&type=template&id=bf51a436"
import script from "./ExercisePresetEdit.vue?vue&type=script&lang=js"
export * from "./ExercisePresetEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports